<template>
  <div>
    <!-- 商品库 -->
    <baseBreadcrumb :page="$t('message.commodityWarehouse')" :menu="$t('message.favorites')"></baseBreadcrumb>
    <div class="body">
      <div class="tags">
        <el-tabs v-model="datas.goods_status" type="card" @tab-click="search">
          <!-- 全部商品100 -->
          <el-tab-pane :label="$t('message.allGoods')" name="上架中">
          </el-tab-pane>
          <!-- 失效 -->
          <el-tab-pane :label="$t('message.failure')" name="已下架">
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="input">
          <el-input v-model="datas.keywords" placeholder="URL/商品名搜索" clearable></el-input>
        </div>
        <div class="input">
          <el-input v-model="datas.for_sn" placeholder="管理番号" clearable></el-input>
        </div>
        <div class="input">
          <el-input v-model="datas.tag" placeholder="标签搜索" clearable></el-input>
        </div>
        <!--搜索  -->
        <el-button type="primary" @click="search">{{
          $t("message.search")
        }}</el-button>
      </div>
      <!--操作-->
      <div class="operation">
        <!-- 全选 -->
        <el-checkbox v-model="checked" @change="allChecked">
          {{ $t("message.allChecked") }}
        </el-checkbox>
        <!--  提出订单-->
        <el-button type="primary" class="fr" @click="submitOrder" v-if="isAuth(575)">{{ $t("message.submitOrder")
        }}</el-button>
        <!--  在庫確認-->
        <el-button type="primary" class="fr" @click="clearGoodsCache" v-if="isAuth(574)">在庫確認</el-button>
        <!--  删除-->
        <el-button type="primary" class="fr" @click="deleteGoods('all', '')" v-if="isAuth(572)">{{ $t("message.delete")
        }}</el-button>
        <!--  追加-->
        <el-button type="primary" class="fr" v-if="isAuth(571)" @click="
          addGoods = true;
        status = true;
        editGoodsDialogVisible = true;
        ">{{ $t("message.additional") }}</el-button>
        <!--  Excel导入-->
        <el-button type="primary" class="fr" v-if="isAuth(573)" @click="
          excelImportDialogVisible = true;
        status = true;
        ">{{ $t("message.excelImport") }}</el-button>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <!-- 番号 -->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!-- 選択 -->
          <li class="flex05">{{ $t("message.sentaku") }}</li>
          <!-- 管理番号 -->
          <li>{{ $t("message.managementDesignation") }}</li>
          <!-- 写真 -->
          <li>{{ $t("message.photo") }}</li>
          <!-- 商品标题 -->
          <li class="flex2">{{ $t("message.commodityTitle") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
          <!-- option -->
          <li class="flex15">option</li>
          <!-- 标签设置 -->
          <li>{{ $t("message.labelSetting") }}</li>
          <!-- 備考欄 -->
          <li class="flex15">{{ $t("message.remarksField") }}</li>
          <!-- 操作 -->
          <li class="flex15">{{ $t("message.operation") }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 番号 -->
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 選択 -->
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="changeChecked"></el-checkbox>
          </li>
          <!-- 管理番号 -->
          <li>{{ item.for_sn }}</li>
          <!-- 写真 -->
          <li>
            <el-popover placement="right" width="300" trigger="hover">
              <img :src="item.img_url" alt="" style="width: 300px; height: 300px" />
              <a href="JavaScript:;" slot="reference">
                <el-image :src="item.img_url" style="width: 60px; height: 60px; border-radius: 4px" v-if="item.img_url">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-popover>
          </li>
          <!-- 商品标题 -->
          <li class="flex2">{{ item.goods_title }}</li>
          <!-- 商品属性 -->
          <li class="flex15">
            <div class="attribute">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(itemDetail, itemIndex) in item.detail_edit != false
                    ? item.detail_edit
                    : item.detail" :key="itemIndex" style="margin-bottom: 5px">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
                <div>
                  <div class="row" v-for="(itemDetail, itemIndex) in item.detail_edit != false
                    ? item.detail_edit
                    : item.detail" :key="itemIndex">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- option -->
          <li class="flex15">
            <div class="attribute">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex" style="margin-bottom: 3px">
                    <p v-if="opti.num > 0">
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                      <span v-else> {{ opti.price }}% </span>
                    </p>
                  </div>
                </div>
                <div style="height: 70px">
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                    <p v-if="opti.num > 0">
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                      <span v-else> {{ opti.price }}% </span>
                    </p>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- 标签设置 -->
          <li>
            <div class="inventory_tag">
              <div v-for="(items, indexs) in item.inventory_tag" :key="indexs" class="template">
                <div class="row" style="margin-bottom: 5px">
                  类别：{{ items.type }}
                </div>
                <div class="row" style="margin-bottom: 5px">
                  标签号：{{ items.no }}
                </div>
                <div class="row" style="margin-bottom: 5px">
                  商品码：{{ items.goods_no }}
                </div>
              </div>
            </div>
          </li>
          <!-- 備考欄 -->
          <li class="flex15">{{ item.note }}</li>
          <!-- 操作 -->
          <li class="flex15">
            <div class="btnList">
              <!-- 删除 -->
              <span class="alink red" @click="deleteGoods('noAll', item)" v-if="isAuth(572)">{{ $t("message.delete")
              }}</span>
              <!-- 编辑 -->
              <span class="alink primary" v-if="isAuth(571)" @click="
                editGoodsMe(item);
              addGoods = false;
              status = true;
              ">{{ $t("message.redact") }}</span>
              <!-- 复制 -->
              <span class="alink" @click="copy(item)" v-if="isAuth(571)">{{
                $t("message.copy")
              }}</span>
            </div>
          </li>
        </ul>
        <!-- 暂无数据 -->
        <div v-if="tableData == false" class="No_data">暂无数据</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="dialogContainer" v-if="status">
      <!-- Excel导入 -->
      <el-dialog width="400px" :close-on-click-modal="false" :close-on-press-escape="false"
        :title="$t('message.excelImport')" :visible.sync="excelImportDialogVisible">
        <excelImport @closeExcelImportDialogVisible="closeExcelImportDialogVisible" />
      </el-dialog>
      <!-- 追加/编辑 -->
      <el-dialog width="800px" :title="addGoods == true ? $t('message.additional') : $t('message.compile')
        " :close-on-click-modal="false" :close-on-press-escape="false" @close="deleteDialogVisibleData"
        :visible.sync="editGoodsDialogVisible">
        <editGoods ref="editGoods" @closeEditGoodsDialogVisible="closeEditGoodsDialogVisible" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import excelImport from "./components/excelImport.vue";
import editGoods from "./components/editGoods.vue";
export default {
  components: {
    editGoods,
    excelImport,
  },
  data() {
    return {
      datas: {
        goods_status: "上架中",
        keywords: "",
        for_sn: "",
        tag: "",
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      },
      total: 0,
      checked: false,
      tableData: [],

      //<!-------------- 商品编辑的参数----------------
      goodsInfo: {},
      goodIndex: 0,
      addGoods: false,
      editGoodsDialogVisible: false,
      status: false,
      optionList: [],
      excelImportDialogVisible: false,
      inventoryTagOption: [],
      //-------------- 商品编辑的参数----------------!>
    };
  },
  created() {
    this.getData();
    this.getOption();
    this.getTagList();
  },
  methods: {
    //<!-------------------- 编辑商品库事件  ---------------------------

    //关闭excel导入弹窗
    closeExcelImportDialogVisible(msg) {
      this.excelImportDialogVisible = false;
    },
    // 获取tag列表
    getTagList() {
      this.$api.clienteleApi.orderDetailTagList({}).then((res) => {
        res.data.forEach((item) => {
          item.no = "";
          item.goods_no = "";
        });
        this.inventoryTagOption = res.data;
      });
    },
    // 获取option列表
    getOption() {
      this.$api.orderApi.orderOptionList(this.datas).then((res) => {
        res.data.forEach((item) => {
          item.checked = false;
        });
        this.optionList = res.data;
      });
    },
    // 深度克隆
    deepClone(obj) {
      // 对常见的“非”值，直接返回原来值
      if ([null, undefined, NaN, false].includes(obj)) return obj;
      if (typeof obj !== "object" && typeof obj !== "function") {
        //原始类型直接返回
        return obj;
      }
      var o = Array.isArray(obj) ? [] : {};
      for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
          o[i] = typeof obj[i] === "object" ? this.deepClone(obj[i]) : obj[i];
        }
      }
      return o;
    },

    //删除商品库商品
    deleteGoods(type, item) {
      let arr = [];
      if (type !== "all") {
        arr.push(item.id);
      } else {
        this.tableData.forEach((listsItem) => {
          if (listsItem.checked === true) {
            arr.push(listsItem.id);
          }
        });
      }
      if (arr.length === 0) {
        // 请至少选择一个商品
        this.$message.error(this.$t("message.pleaseSelectAtLeastOneProduct"));
        return;
      }
      // 确认删除选中的商品吗？
      // 提示
      this.$confirm(
        this.$t("message.areYouSureToDeleteTheSelectedProduct"),
        this.$t("message.hint"),
        {
          // 确定

          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.clienteleApi
            .clientinventoryDelete({
              user_id: this.$route.query.userID,
              id: arr,
            })
            .then((res) => {
              if (res.code != 0) return;
              if (this.checked == true) {
                this.checked = false;
              }
              this.getData();
              this.$forceUpdate();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            // 已取消删除
            message: this.$t("message.theDeletionHasBeenCancelled"),
          });
        });
    },
    // 新增或编辑商品库信息
    closeEditGoodsDialogVisible() {
      this.editGoodsDialogVisible = false;
      this.getData();
      this.goodIndex = null;
      this.status = false;
      this.$refs.editGoods.url = "";
    },
    //删除
    deleteDialogVisibleData() {
      this.goodsInfo = {};
      this.$refs.editGoods.url = "";
      this.optionList.forEach((item) => {
        item.checked = false;
      });
      this.goodIndex = null;
      this.status = false;
    },
    //编辑商品库商品
    editGoodsMe(item) {
      if (item.option != null) {
        if (item.option.length > 0) {
          this.optionList.forEach((oldOption) => {
            item.option.forEach((goodsOption) => {
              if (oldOption.id === goodsOption.id) {
                oldOption.checked = true;
              }
            });
          });
        }
      }

      if (item.goods_id == "") {
        this.$message.error(
          // 该商品因库存不足或其他原因已经找不到，请查看其他商品！
          this.$t("message.theProducerProducts")
        );
        return;
      }
      if (item.goodsInfo == undefined) {
        this.$api.clienteleApi
          .goodsAttribute({
            shop_type: item.shop_type,
            goods_id: item.goods_id,
          })
          .then((res) => {
            if (
              res.data[0].goodsInventory.length > 0 &&
              res.data[0].specification.length > 0
            ) {
              item.goodsInfo = {
                goodsInventory: this.deepClone(res.data[0].goodsInventory),
                specification: this.deepClone(res.data[0].specification),
              };
              if (res.data[0].specification.length > 0) {
                item.goodsInfo.specification.forEach((specificationItem) => {
                  specificationItem.valueC.forEach(
                    (valueCItem, valueCIndex) => {
                      item.detail.forEach((detailItem) => {
                        if (
                          specificationItem.keyC === detailItem.key &&
                          valueCItem.name === detailItem.value
                        ) {
                          specificationItem.active = valueCIndex;
                        }
                      });
                    }
                  );
                });
              }
            } else {
              item.goodsInfo = {
                goodsInventory: [],
                specification: [],
              };
              item.detail.forEach((detailItem) => {
                item.goodsInfo.specification.push({
                  keyC: detailItem.key,
                  keyT: detailItem.key,
                  active: 0,
                  valueC: [{ name: detailItem.value, picUrl: "" }],
                  valueT: [{ name: detailItem.value, picUrl: "" }],
                });
              });
            }
            this.goodsInfo = this.deepClone(item);
            this.editGoodsDialogVisible = true;
            setTimeout(() => {
              this.$refs.editGoods.artificialAttributeEditList =
                item.detail_edit;
              if (item.detail_edit.length > 0) {
                this.$refs.editGoods.attributeTypeStatus = 2;
              }
            }, 0);
          });
      } else {
        if (item.goodsInfo.specification.length > 0) {
          item.goodsInfo.specification.forEach((specificationItem) => {
            specificationItem.valueC.forEach((valueCItem, valueCIndex) => {
              item.detail.forEach((detailItem) => {
                if (
                  specificationItem.keyC === detailItem.key &&
                  valueCItem.name === detailItem.value
                ) {
                  specificationItem.active = valueCIndex;
                }
              });
            });
          });
        }
        this.goodsInfo = this.deepClone(item);
        this.editGoodsDialogVisible = true;
        setTimeout(() => {
          this.$refs.editGoods.artificialAttributeEditList = item.detail_edit;
          if (item.detail_edit.length > 0) {
            this.$refs.editGoods.attributeTypeStatus = 2;
          }
        }, 0);
      }
    },
    //复制商品库商品
    copy(item) {
      this.status = true;
      this.addGoods = true;
      this.goodIndex = item.id;
      if (item.option.length > 0) {
        this.optionList.forEach((oldOption) => {
          item.option.forEach((goodsOption) => {
            if (oldOption.id === goodsOption.id) {
              oldOption.checked = true;
            }
          });
        });
      }
      this.editGoodsDialogVisible = true;
      if (item.goods_id == "") {
        this.$message.error(
          // 该商品因库存不足或其他原因已经找不到，请查看其他商品！
          this.$t("message.theProducerProducts")
        );
        return;
      }
      this.goodsInfo = {
        for_sn: item.for_sn,
        note: item.note,
        num: item.num,
        img_url: item.img_url,
        shop_name: item.shop_name,
        goods_title: item.goods_title,
        shop_type: item.shop_type,
        shop_id: item.shop_id,
        goods_id: item.goods_id,
        detail_edit: item.detail_edit,
        price: item.price,
      };
      let tagValue = "";
      let inventoryTagOption = this.deepClone(this.inventoryTagOption);
      item.inventory_tag.forEach((item) => {
        inventoryTagOption.forEach((optionItem) => {
          if (optionItem.type === item.type) {
            tagValue = item.type;
            optionItem.no = item.no;
            optionItem.goods_no = item.goods_no;
          }
        });
      });
      if (item.goodsInfo == undefined) {
        this.$api.clienteleApi
          .goodsAttribute({
            shop_type: item.shop_type,
            goods_id: item.goods_id,
          })
          .then((res) => {
            if (
              res.data[0].goodsInventory.length > 0 &&
              res.data[0].specification.length > 0
            ) {
              item.goodsInfo = {
                goodsInventory: this.deepClone(res.data[0].goodsInventory),
                specification: this.deepClone(res.data[0].specification),
              };
              if (res.data[0].specification.length > 0) {
                item.goodsInfo.specification.forEach((specificationItem) => {
                  specificationItem.valueC.forEach(
                    (valueCItem, valueCIndex) => {
                      item.detail.forEach((detailItem) => {
                        if (
                          specificationItem.keyC === detailItem.key &&
                          valueCItem.name === detailItem.value
                        ) {
                          specificationItem.active = valueCIndex;
                        }
                      });
                    }
                  );
                });
              }
            } else {
              item.goodsInfo = {
                goodsInventory: [],
                specification: [],
              };
              item.detail.forEach((detailItem) => {
                item.goodsInfo.specification.push({
                  keyC: detailItem.key,
                  keyT: detailItem.key,
                  active: 0,
                  valueC: [{ name: detailItem.value, picUrl: "" }],
                  valueT: [{ name: detailItem.value, picUrl: "" }],
                });
              });
            }
            this.goodsInfo = this.deepClone(item);
            this.editGoodsDialogVisible = true;
            setTimeout(() => {
              this.$refs.editGoods.artificialAttributeEditList =
                item.detail_edit;
              if (item.detail_edit.length > 0) {
                this.$refs.editGoods.attributeTypeStatus = 2;
              }
            }, 0);
          });
      } else {
        if (item.goodsInfo.specification.length > 0) {
          item.goodsInfo.specification.forEach((specificationItem) => {
            specificationItem.valueC.forEach((valueCItem, valueCIndex) => {
              item.detail.forEach((detailItem) => {
                if (
                  specificationItem.keyC === detailItem.key &&
                  valueCItem.name === detailItem.value
                ) {
                  specificationItem.active = valueCIndex;
                }
              });
            });
          });
        }
        this.goodsInfo = this.deepClone(item);
        this.editGoodsDialogVisible = true;
        setTimeout(() => {
          this.$refs.editGoods.artificialAttributeEditList = item.detail_edit;
          if (item.detail_edit.length > 0) {
            this.$refs.editGoods.attributeTypeStatus = 2;
          }
        }, 0);
      }
      setTimeout(() => {
        this.$refs.editGoods.inventoryTagOption = inventoryTagOption;
        this.$refs.editGoods.tagValue = tagValue;
      }, 1000);
    },
    // ----------------------------  编辑商品库事件  ------------------!>
    // 客户-商品库列表
    getData() {
      this.$api.clienteleApi.inventoryList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.checked = false;
        });
        this.checked = false;
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.getData();
    },
    // 重置
    reset() {
      this.datas = {
        goods_status: "上架中",
        keywords: "",
        for_sn: "",
        tag: "",
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      };

      this.$forceUpdate();
      this.getData();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.getData();
    },
    //全选
    allChecked() {
      this.tableData.forEach((item) => {
        item.checked = this.checked;
      });
    },
    // 单选
    changeChecked() {
      this.checked = this.tableData.every((item) => item.checked);
    },
    // 提出订单
    submitOrder() {
      let ids = [];
      this.tableData.forEach((item) => {
        if (item.checked) {
          ids.push(item.id);
        }
      });
      if (ids == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      ids = ids.join(",");
      let routeUrl = this.$router.resolve({
        path: "/orderPreview?userID=" + this.datas.user_id + "&ids=" + ids,
      });
      window.open(routeUrl.href, "_blank");
    },
    //-清除商品缓存
    clearGoodsCache() {
      let datas = {
        clear_data: [],
      };
      this.tableData.forEach((item) => {
        if (item.checked) {
          datas.clear_data.push({
            goods_id: item.goods_id,
            shop_type: item.shop_type,
          });
        }
      });
      if (datas.clear_data == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );

      this.$api.clienteleApi.clearGoodsCache(datas).then((res) => {
        this.$message.success(res.msg);
        this.getData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./css/collection.scss";

div {
  word-break: break-all;
}

.search {
  display: flex;

  .input {
    margin-right: 20px;
  }
}

.operation {
  height: 40px;
  line-height: 40px;
  margin: 20px 0;

  .fr {
    margin-left: 20px;
  }
}

.table {
  .template {
    max-height: 100px;
    overflow-y: auto;

  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: left;
    width: 100%;


    .row {
      width: 100%;
      text-align: left;
    }

    a {
      color: #fa5058;
      text-decoration: underline;
    }
  }

  .inventory_tag {
    width: 100%;
  }

  .attribute {
    width: 100%;
    text-align: left;
    padding: 0 10px;
    height: 100%;
    overflow: hidden;
  }

  .el-icon-sold-out {
    color: #fa5058;
    font-size: 40px;
    cursor: pointer;
  }

  .No_data {
    margin: 20px auto;
    text-align: center;
    font-size: 20px;
  }
}

.btnList {
  .alink {
    margin: 0 5px;
    cursor: pointer;
  }

  .alink.red {
    color: #fa5058 !important;
    background-color: white !important;
  }

  .alink.primary {
    color: #409eff !important;
    background-color: white !important;
  }
}
</style>
